<template>
  <div v-if="photos && photos.length" class="d-flex" style="flex-wrap:wrap">
    <a
      v-for="(photo, ix) in photos"
      :key="ix"
      class="mr-1 mb-1"
      @click.stop="openPhoto(ix)"
    >
      <img
        :src="thumbUrl(photo.url)"
        :height="size"
        :width="size"
        class="service-photo-thumb"
      />
    </a>
    <!-- PHOTOS DIALOG -->
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-divider vertical class="ml-2 mr-4"></v-divider>
        <v-icon @click="prevPhoto" class="mr-3">
          chevron_left
        </v-icon>
        {{ carousel + 1 }}/{{ photos.length }}
        <v-icon @click="nextPhoto" class="ml-3">
          chevron_right
        </v-icon>
        <v-toolbar-title class="ml-3">
          Service Photos
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="downloadImage" class="mr-2">
          file_download
        </v-icon>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-carousel
            v-model="carousel"
            hide-delimiter-background
            hide-delimiters
            height="auto"
            :show-arrows="false"
            class="pt-2"
          >
            <v-carousel-item v-for="(photo, ix) in photos" :key="ix">
              <v-img :src="largeUrl(photo.url)" contain max-height="80vh"></v-img>
              <div
                class="text-center caption grey--text mt-2"
                v-if="photo.uploadedBy"
              >
                Added by {{ photo.uploadedBy.firstName }}
                {{ photo.uploadedBy.lastName }}
              </div>
            </v-carousel-item>
          </v-carousel>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    photos: {
      type: Array,
      default: () => [],
    },
    size: {
      type: [String, Number],
      default: 60,
    },
  },
  data() {
    return {
      dialog: false,
      carousel: 0,
    };
  },
  methods: {
    thumbUrl(url) {
      return url.replace(
        "https://firebasestorage.googleapis.com/",
        "https://ik.imagekit.io/albademo/tr:w-100/",
      );
    },
    largeUrl(url) {
      return url.replace(
        "https://firebasestorage.googleapis.com/",
        "https://ik.imagekit.io/albademo/tr:w-1400/",
      );
    },
    openPhoto(ix) {
      this.carousel = ix;
      this.dialog = true;
    },
    prevPhoto() {
      if (this.carousel > 0) {
        this.carousel--;
      }
    },
    nextPhoto() {
      if (this.carousel < this.photos.length - 1) {
        this.carousel++;
      }
    },
    async downloadImage() {
      const photo = this.photos[this.carousel];
      const imageKitUrl = photo.url.replace(
        "https://firebasestorage.googleapis.com/",
        "https://ik.imagekit.io/albademo/",
      );
      try {
        const response = await fetch(imageKitUrl);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `service_photo_${this.carousel + 1}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.log("ImageKit fetch failed, opening in new tab:", error.message);
        window.open(photo.url, "_blank");
      }
    },
  },
};
</script>
<style scoped>
.service-photo-thumb {
  object-fit: cover;
  display: block;
  border-radius: 2px;
}
</style>
